import { render, staticRenderFns } from "./EditCampaignConfiguration.vue?vue&type=template&id=4a660ded&lang=pug&"
import script from "./EditCampaignConfiguration.vue?vue&type=script&lang=js&"
export * from "./EditCampaignConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports